export var MedicalTitleName;
(function (MedicalTitleName) {
    // Unsupported titles
    /** Medical Assistant */
    MedicalTitleName["MA"] = "ma";
    /** Medical Doctor */
    MedicalTitleName["MD"] = "md";
    /** Nurse Practitioner */
    MedicalTitleName["NP"] = "np";
    /** Naturopathic Doctor */
    MedicalTitleName["ND"] = "nd";
    /** Physician Assistant */
    MedicalTitleName["PA"] = "pa";
    // Supported titles
    /** Licensed Vocational Nurse */
    MedicalTitleName["LVN"] = "lvn";
    MedicalTitleName["PHLEBOTOMIST"] = "phlebotomist";
    /** Registered Nurse */
    MedicalTitleName["RN"] = "rn";
})(MedicalTitleName || (MedicalTitleName = {}));
/**
 * Ordered medical titles from highest to lowest
 */
export const orderedMedicalTitleRanking = [
    MedicalTitleName.RN,
    MedicalTitleName.LVN,
    MedicalTitleName.PHLEBOTOMIST,
];
export var ProcedureFlowType;
(function (ProcedureFlowType) {
    /**
     * Procedure flow including:
     * - Product selection
     * - Generic files upload (optional)
     * - Nurse instructions (optional)
     * - Fasting instructions (optional)
     */
    ProcedureFlowType["GENERIC"] = "generic";
    /**
     * Procedure flow including:
     * - Product selection
     * - Requisition form upload (optional)
     * - Diagnosis
     * - Nurse instructions (optional)
     * - Fasting instructions
     * - Lab selection
     */
    ProcedureFlowType["LAB_DRAW"] = "labDraw";
    /**
     * Procedure flow including:
     * - Product selection
     */
    ProcedureFlowType["POINT_OF_CARE"] = "pointOfCare";
})(ProcedureFlowType || (ProcedureFlowType = {}));
export var InstructionType;
(function (InstructionType) {
    InstructionType["CHARTING"] = "charting";
    InstructionType["STORAGE"] = "storage";
    InstructionType["DRAWING"] = "drawing";
    InstructionType["SAMPLE_MANIPULATION"] = "sampleManipulation";
    InstructionType["POST_PROCEDURE"] = "postProcedure";
    InstructionType["FASTING"] = "fasting";
    InstructionType["PATIENT"] = "patient";
    InstructionType["CONSENT"] = "consent";
    InstructionType["NURSE"] = "nurse";
    InstructionType["DIAGNOSIS"] = "diagnosis";
    InstructionType["LAB"] = "lab";
})(InstructionType || (InstructionType = {}));
export var ConfigType;
(function (ConfigType) {
    ConfigType["PCR"] = "pcr";
    ConfigType["TUBE"] = "tube";
    ConfigType["URINE"] = "urine";
})(ConfigType || (ConfigType = {}));
/**
 * CARE-5306
 *
 * These are specific products in the production database which require
 * the cancerguard support phone number to be displayed instead of the
 * default support phone number
*/
export const CANCERGUARD_PRODUCT_ID = 'n885XgJJRkZIPu4JwKKN';
export const ONCOGUARD_LIVER_PRODUCT_ID = 'SoOebwNfDOFUNxFppbTz';
export const cancerguardSupportedProducts = [
    CANCERGUARD_PRODUCT_ID,
    ONCOGUARD_LIVER_PRODUCT_ID,
];
export var DurationType;
(function (DurationType) {
    DurationType["PREPARATION"] = "preparation";
    DurationType["PROCEDURE"] = "procedure";
    DurationType["OBSERVATION"] = "observation";
})(DurationType || (DurationType = {}));
export const CANCERGUARD_SUPPORT_PHONE_NUMBER = '+1 844-870-8870';
export const EXAS_SUPPORT_PHONE_NUMBER = '+1 888-662-6897';
//# sourceMappingURL=variables.js.map